// extracted by mini-css-extract-plugin
export default {"menu":"MessageActionMenu_menu__AdLDF","menuFadeIn":"MessageActionMenu_menuFadeIn__Jh77R","item":"MessageActionMenu_item__mQURA","destructive":"MessageActionMenu_destructive__8XGfZ"};